import * as React from "react";
import { BlockProps } from "baseui/block";
import { ParagraphSmall } from "kanopi-components/typography";

export const DisplayLabel = ({
  children,
  ...props
}: { children?: string } & BlockProps) => (
  <ParagraphSmall
    overrides={{
      Block: {
        style: {
          fontSize: "inherit",
        },
      },
    }}
    margin={0}
    {...props}
  >
    {children}
  </ParagraphSmall>
);
